import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  START_AUTO_RENEW_LOADING,
  START_AUTO_RENEW_ERROR,
  START_AUTO_RENEW_START,
  START_AUTO_RENEW_SUCCESS,
  START_AUTO_RENEW_CANCEL,
} from '@src/app/accounts/startautorenew/actions';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
export type State = {
  readonly loading: boolean;
  startAutoRenewSavedResult: Object | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case START_AUTO_RENEW_ERROR:
      case START_AUTO_RENEW_START:
      case OMS_LOOKUP_SUCCESS:
        return false;
      case START_AUTO_RENEW_LOADING:
        return action.payload;
      default:
        return state;
    }
  },

  startAutoRenewSavedResult: (state = null, action) => {
    switch (action.type) {
      case START_AUTO_RENEW_SUCCESS:
      case START_AUTO_RENEW_ERROR:
        return action.payload;
      case START_AUTO_RENEW_CANCEL:
      case START_AUTO_RENEW_START:
        return null;
      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/startautorenew/reducer.ts